var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgHappyNacho(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 76,
    viewBox: "0 0 81 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1915 59.6771C59.1007 62.7932 55.6381 64.6124 53.0206 62.9191L22.3834 43.1C19.8714 41.475 19.9671 37.7684 22.5597 36.2753L54.3072 17.9909C57.0189 16.4291 60.3929 18.4457 60.3018 21.5736L59.1915 59.6771Z",
    fill: "#70DFBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4069 39.2616C41.1194 37.9091 39.7899 37.0457 38.4374 37.3332C37.0849 37.6207 36.2216 38.9502 36.5091 40.3027",
    stroke: "#181351",
    strokeWidth: 2.70812,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4113 36.8126C52.1238 35.4601 50.7943 34.5968 49.4418 34.8843C48.0893 35.1717 47.226 36.5012 47.5135 37.8537",
    stroke: "#181351",
    strokeWidth: 2.70812,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3188 51.5689C51.0229 50.9403 53.5558 47.3432 53.3192 43.2941C53.287 42.7428 52.7646 42.3754 52.2201 42.4678L39.6895 44.5942C39.145 44.6866 38.7731 45.2057 38.9245 45.7369C40.037 49.6373 43.6148 52.1974 47.3188 51.5689Z",
    fill: "#181351"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7288 1.53333L69.0314 11.3825",
    stroke: "#AFD4FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8525 6.57312L63.9267 7.74162",
    stroke: "#AFD4FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4893 9.76013L65.7198 3.06048",
    stroke: "#AFD4FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.84839 26.7039L6.69525 32.018",
    stroke: "#70DFBE",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20371 27.9419L2.48762 31.4286",
    stroke: "#70DFBE",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0571 73.2122L21.0105 64.0745",
    stroke: "#AFD4FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7283 71.1384L16.8853 66.408",
    stroke: "#AFD4FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.354 66.408L17.7603 71.1384",
    stroke: "#AFD4FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9229,
    cy: 19.9872,
    r: 1.43115,
    fill: "#70DFBE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 44.7021,
    cy: 6.31238,
    r: 1.43115,
    fill: "#70DFBE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.9885,
    cy: 73.911,
    r: 1.43115,
    fill: "#FD8B98"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 8.86572,
    cy: 57.1548,
    r: 1.93115,
    fill: "#70B1FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 70.0985,
    cy: 63.8077,
    r: 1.43115,
    transform: "rotate(71.9064 70.0985 63.8077)",
    fill: "#70DFBE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 65.8763,
    cy: 68.5022,
    r: 1.43115,
    transform: "rotate(71.9064 65.8763 68.5022)",
    fill: "#70DFBE"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 65.7164,
    cy: 59.6124,
    r: 1.43115,
    transform: "rotate(71.9064 65.7164 59.6124)",
    fill: "#70DFBE"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 74.7093,
    cy: 59.4871,
    r: 1.43115,
    transform: "rotate(71.9064 74.7093 59.4871)",
    fill: "#70DFBE"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 70.3273,
    cy: 55.292,
    r: 1.43115,
    transform: "rotate(71.9064 70.3273 55.292)",
    fill: "#70DFBE"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 65.9454,
    cy: 51.097,
    r: 1.43115,
    transform: "rotate(71.9064 65.9454 51.097)",
    fill: "#70DFBE"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 79.2618,
    cy: 54.9886,
    r: 1.43115,
    transform: "rotate(71.9064 79.2618 54.9886)",
    fill: "#70DFBE"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 74.8797,
    cy: 50.793,
    r: 1.43115,
    transform: "rotate(71.9064 74.8797 50.793)",
    fill: "#70DFBE"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 70.4977,
    cy: 46.5977,
    r: 1.43115,
    transform: "rotate(71.9064 70.4977 46.5977)",
    fill: "#70DFBE"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 66.1163,
    cy: 42.4026,
    r: 1.43115,
    transform: "rotate(71.9064 66.1163 42.4026)",
    fill: "#70DFBE"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.811,
    cy: 8.81335,
    r: 3.11792,
    fill: "#FD8B98"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyNacho);
export default __webpack_public_path__ + "static/media/happy_nacho.4f2b9101b85dba87b70db19f7032e812.svg";
export { ForwardRef as ReactComponent };